module.exports = __webpack_public_path__ + "static/media/help-click-to-fill-white.7382dbd7.png";